import React from "react";

const defaultTrainingData = [
  {
    segment: "Board of directors",
    totalPrograms: "",
    topicsCovered: "",
    coveragePercentage: "",
  },
  {
    segment: "Key managerial personnel",
    totalPrograms: "",
    topicsCovered: "",
    coveragePercentage: "",
  },
  {
    segment: "Employees",
    totalPrograms: "",
    topicsCovered: "",
    coveragePercentage: "",
  },
  {
    segment: "Workers",
    totalPrograms: "",
    topicsCovered: "",
    coveragePercentage: "",
  },
];

const TrainingAwarenessTable = ({ trainingData, setTrainingData }) => {
  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...trainingData];
    updated[rowIndex][field] = value;
    setTrainingData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Segment</th>
            <th style={tableHeaderStyle}>
              Total number of training and awareness programs held
            </th>
            <th style={tableHeaderStyle}>
              Topics covered under the training and its impacts
            </th>
            <th style={tableHeaderStyle}>
              % of persons in respective category covered by awareness program
            </th>
          </tr>
        </thead>
        <tbody>
          {trainingData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.segment}
              </td>
              <td style={tableCellStyle}>
                <textarea
                  placeholder="Number of training & awareness program"
                  value={row.totalPrograms}
                  onChange={(e) =>
                    handleInputChange(rowIndex, "totalPrograms", e.target.value)
                  }
                  style={textareaStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <textarea
                  placeholder="Topics covered under the training & its impacts"
                  value={row.topicsCovered}
                  onChange={(e) =>
                    handleInputChange(rowIndex, "topicsCovered", e.target.value)
                  }
                  style={textareaStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <textarea
                  placeholder="Percentage"
                  value={row.coveragePercentage}
                  onChange={(e) =>
                    handleInputChange(
                      rowIndex,
                      "coveragePercentage",
                      e.target.value
                    )
                  }
                  style={textareaStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const textareaStyle = {
  width: "100%",
  height: "80px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

export default TrainingAwarenessTable;
